import React, { Component } from 'react';
import PageTitle from '../home/PageTitle';
import LocalStorageHelper from '../../LocalStorageHelper/LocalStorageHelper';
import AgGridComponent from '../common/AgGridComponent';
import PaginationComponent, { DEFAULT_PAGE_SIZE, DEFAULT_PAGE_SIZE_OPTIONS } from '../common/PaginationComponent';
import { createMasterActionColumn, createMasterActiveColumn } from '../../utils/masterGridHelpers';
import {
    buildMasterGridParams,
    VENDOR_SORT_WHITELIST,
    VENDOR_FILTER_WHITELIST,
} from '../../utils/agGridServerHelpers';
import ApiURL from '../../api/ApiURL';
import cogoToast from 'cogo-toast';
import axios from 'axios';

class Vendor extends Component {
    //constructor lifecycle event
    constructor(props) {
        super(props);
        ////register Handsontable's modules
        //registerAllModules();
        this.state = {
            showModal: false,
            showDeleteWarnModal: false,
            tcData: [],
            locationData: [],
            vendorCategoryData: [],
            vendorData: [],
            columnDefs: [],
            sortModel: [],
            filterModel: {},
            isTableLoading: true,
            currentPage: 1,
            pageSize: DEFAULT_PAGE_SIZE,
            totalRecords: 0,
            travelCircuitId: 0,
            locationId: 0,
            vendorId: 0,
            vendorName: '',
            vendorCategoryId: 0,
            addressLine: '',
            city: '',
            pincode: '',
            contactPerson: '',
            contactNo: '',
            email: '',
            licenceNo: '',
            cin: '',
            gstin: '',
            pan: '',
            comment: '',
            userId: 0,
            userRole: '',
            isActive: true
        };
    }
    //componentDidMount lifecycle event
    componentDidMount() {
        window.scroll(0, 0);
        var userData = JSON.parse(LocalStorageHelper.getUser());
        if (userData !== null && userData.UserId > 0) {
            this.setState({
                userId: userData.UserId,
                userRole: userData.RoleName,
                displayName: userData.DisplayName
            })
        }
        this.getAllTCData();
        this.getAllVendorCategoryData();
        this.getAllVendorData();
        this.getAllDataColumns();
    }
    //Data Reload
    handleReload = () => this.setState({ currentPage: 1 }, this.getAllVendorData);
    handleSortChange = (sortModel) => {
        this.setState({ sortModel, currentPage: 1 }, this.getAllVendorData);
    };
    handleFilterChange = (filterModel) => {
        this.setState({ filterModel, currentPage: 1 }, this.getAllVendorData);
    };
    handlePageChange = (page) => {
        this.setState({ currentPage: page }, this.getAllVendorData);
    };
    handlePageSizeChange = (size) => {
        this.setState({ pageSize: size, currentPage: 1 }, this.getAllVendorData);
    };
    //Reset all input fields into the modal
    resetInputFields = () => {
        this.setState({
            showModal: false,
            showDeleteWarnModal: false,
            travelCircuitId: 0,
            locationId: 0,
            vendorId: 0,
            vendorName: '',
            vendorCategoryId: 0,
            addressLine: '',
            city: '',
            pincode: '',
            contactPerson: '',
            contactNo: '',
            email: '',
            licenceNo: '',
            cin: '',
            gstin: '',
            pan: '',
            comment: '',
            isActive: true
        });
    }
    //Open modal
    openModal = () => this.setState({ showModal: true });
    //Close modal
    closeModal = () => this.setState({ showModal: false });
    //Open Delete warning modal
    openWarnModal = () => this.setState({ showDeleteWarnModal: true });
    //Close Delete warning modal
    closeWarnModal = () => this.setState({ showDeleteWarnModal: false });
    //OnChangeHandler
    handleChange = (e) => {
        if (e.target.name === 'travelCircuitId') {
            this.getAllLocationData(e.target.value)
        }
        this.setState({ [e.target.name]: e.target.value });
    }
    //Get All Travel Circuit Data
    getAllTCData = () => {
        axios
            .get(ApiURL.GetAllTC)
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    var dataResult = respData.DataResult;
                    this.setState({
                        ...this.state,
                        tcData: dataResult,
                    });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }
    //Get all Location data
    getAllLocationData = (tcId) => {
        axios
            .get(ApiURL.GetAllLocationByTC(tcId))
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    var dataResult = respData.DataResult;
                    console.log(dataResult);
                    this.setState({ locationData: dataResult });
                }
                if (respData.StatusCode === 404) {
                    this.setState({ locationData: [] });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }
    //Get all Vendor Category data
    getAllVendorCategoryData = () => {
        axios
            .get(ApiURL.GetAllVendorCategory)
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    var dataResult = respData.DataResult;
                    this.setState({ vendorCategoryData: dataResult });
                }
                if (respData.StatusCode === 404) {
                    this.setState({ vendorCategoryData: [] });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }
    //Get all data
    getAllVendorData = () => {
        const { currentPage, pageSize, sortModel, filterModel } = this.state;
        const param = buildMasterGridParams(
            currentPage,
            pageSize,
            sortModel,
            filterModel,
            VENDOR_SORT_WHITELIST,
            VENDOR_FILTER_WHITELIST
        );
        this.setState({ isTableLoading: true });
        axios
            .post(ApiURL.GetAllVendor, param)
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    var dataResult = respData.DataResult;
                    this.setState({
                        vendorData: dataResult.Vendors,
                        totalRecords: dataResult?.TotalRecords ?? 0,
                    });
                } else if (respData.StatusCode === 404) {
                    this.setState({ vendorData: [], totalRecords: 0 });
                } else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            })
            .finally(() => {
                this.setState({ isTableLoading: false });
            });
    }
    //Get all columns
    getAllDataColumns = () => {
        this.setState({
            columnDefs: [
                createMasterActionColumn(this.getDataItemById, "VendorId"),
                { headerName: "Vendor", field: "VendorName", flex: 1.5, minWidth: 140, cellClass: "text-left" },
                { headerName: "Vendor Category", field: "VendorCategoryName", width: 140, cellClass: "text-center" },
                { headerName: "LocationName", field: "LocationName", width: 130, cellClass: "text-center" },
                { headerName: "ContactNo", field: "ContactNo", width: 120, cellClass: "text-center" },
                { headerName: "Email", field: "Email", flex: 1, minWidth: 140, cellClass: "text-left" },
                { headerName: "PAN", field: "PAN", width: 120, cellClass: "text-left" },
                createMasterActiveColumn(),
            ],
        })
    }
    //Get data by Id
    getDataItemById = (keyData) => {
        var self = this;
        axios
            .get(ApiURL.GetVendorById(keyData))
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    var dataResult = respData.DataResult;
                    console.log(dataResult);
                    self.setState({
                        vendorId: dataResult.VendorId,
                        travelCircuitId: dataResult.TravelCircuitId,
                        locationId: dataResult.LocationId,
                        vendorId: dataResult.VendorId,
                        vendorName: dataResult.VendorName,
                        vendorCategoryId: dataResult.VendorCategoryId,
                        addressLine: dataResult.AddressLine,
                        contactPerson: dataResult.ContactPerson,
                        contactNo: dataResult.ContactNo,
                        email: dataResult.Email,
                        licenceNo: dataResult.LicenceNo,
                        cin: dataResult.CIN,
                        gstin: dataResult.GSTIN,
                        pan: dataResult.PAN,
                        comment: dataResult.Comment,
                        isActive: dataResult.IsActive,
                        showModal: true,
                    }, () => {
                        self.getAllLocationData(dataResult.TravelCircuitId);
                    });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }
    //Handle Add new Record
    handleAddNew = () => {
        this.resetInputFields();
        this.openModal();
    }
    //Delete data by Id
    handleDelete = () => {
        const { locationId, vendorCategoryId, vendorId, vendorName, addressLine, city, pincode, contactNo, contactPerson,
            email, licenceNo, cin, gstin, pan, comment, userId } = this.state;
        let param = {
            VendorId: vendorId,
            VendorName: vendorName,
            VendorCategoryId: vendorCategoryId,
            LocationId: locationId,
            AddressLine: addressLine,
            City: city,
            Pincode: pincode,
            ContactNo: contactNo,
            ContactPerson: contactPerson,
            Email: email,
            LicenceNo: licenceNo,
            CIN: cin,
            GSTIN: gstin,
            PAN: pan,
            Comment: comment,
            CreatedBy: userId,
            UpdatedBy: userId,
            IsActive: false
        };
        axios.post(ApiURL.SaveVendor, param)
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    cogoToast.success("Vendor deleted successfully!", { position: "bottom-center" });
                    this.resetInputFields();
                    this.closeWarnModal();
                    this.getAllVendorData();
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }
    //save data
    handleSubmit = (e) => {
        e.preventDefault();
        const { travelCircuitId, locationId, vendorCategoryId, vendorId, vendorName, addressLine, city, pincode,
            contactNo, contactPerson, email, licenceNo, cin, gstin, pan, comment, userId, isActive } = this.state;
        if (travelCircuitId === '0') {
            cogoToast.error("Travel Circuit is required!", { position: "bottom-center" });
        }
        else if (locationId === '0') {
            cogoToast.error("Location is required!", { position: "bottom-center" });
        }
        else if (vendorCategoryId === '0') {
            cogoToast.error("Vendor Category is required!", { position: "bottom-center" });
        }
        else if (vendorName === '') {
            cogoToast.error("Vendor name is required", { position: "bottom-center" });
        }
        else if (email === '') {
            cogoToast.error("Email is required", { position: "bottom-center" });
        }
        else if (contactNo === '') {
            cogoToast.error("Contact No. is required", { position: "bottom-center" });
        }
        else if (pan === '') {
            cogoToast.error("PAN is required", { position: "bottom-center" });
        }
        else {
            let param = {
                VendorId: vendorId,
                VendorName: vendorName,
                VendorCategoryId: vendorCategoryId,
                LocationId: locationId,
                AddressLine: addressLine,
                City: city,
                Pincode: pincode,
                ContactNo: contactNo,
                ContactPerson: contactPerson,
                Email: email,
                LicenceNo: licenceNo,
                CIN: cin,
                GSTIN: gstin,
                PAN: pan,
                Comment: comment,
                CreatedBy: userId,
                UpdatedBy: userId,
                isActive: isActive
            };
            console.log(param);
            axios
                .post(ApiURL.SaveVendor, param)
                .then((response) => {
                    let respData = response.data;
                    if (respData.StatusCode === 200) {
                        cogoToast.success("Vendor saved successfully!", { position: "bottom-center" });
                        this.resetInputFields();
                        this.getAllVendorData();
                    }
                    else if (respData.StatusCode === 500) {
                        cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                    }
                })
                .catch((error) => {
                    cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
                });
        }
    }


    render() {
        const { tcData, locationData, vendorCategoryData, vendorData, showModal, showDeleteWarnModal, columnDefs,
            travelCircuitId, locationId, vendorCategoryId, vendorId, vendorName, addressLine, contactNo, email,
            city, pincode, contactPerson, licenceNo, cin, gstin, pan, comment,
            currentPage, pageSize, totalRecords,
        } = this.state;
        return (
            <>
                <div className="master-page">
                <div className="container-fluid bg-primary-subtle border-bottom border-primary top-action-bar">
                    <div className="card bg-primary-subtle flex-row py-1 mb-0 mx-2">
                        <div className="col-md-9 justify-content-start">
                            <PageTitle Title="Manage Vendor" />
                        </div>
                        <div className="col-md-3 text-right pt-1">
                            <button className="btn btn-outline-dark btn-sm px-3 mx-3" title="Refresh" onClick={this.handleReload}>
                                <i className="fa-solid fa-arrows-rotate"></i> Refresh
                            </button>
                            <button className="btn btn-outline-primary btn-sm px-3 cursor-pointer" title="Add" onClick={this.handleAddNew}>
                                <i className="fa-solid fa-plus"></i> Add
                            </button>
                        </div>
                    </div>
                </div>
                <div className="master-page__body">
                    <PaginationComponent
                        currentPage={currentPage}
                        totalPages={Math.ceil(totalRecords / pageSize) || 1}
                        pageSize={pageSize}
                        totalRecords={totalRecords}
                        pageSizeOptions={DEFAULT_PAGE_SIZE_OPTIONS}
                        onPageChange={this.handlePageChange}
                        onPageSizeChange={this.handlePageSizeChange}
                    />
                    <div className="master-page__grid">
                        <AgGridComponent
                            columnDefs={columnDefs}
                            rowData={vendorData}
                            isLoading={this.state.isTableLoading}
                            onSortChange={this.handleSortChange}
                            onFilterChange={this.handleFilterChange}
                            fillHeight
                        />
                    </div>
                </div>
                </div>

                {/* <!----------------- modal section----------------> */}
                <div className={showModal === true ? "modal show-modal  modalWrapper" : "modal"} tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h1 className="modal-title ">{vendorId <= 0 ? `Add Vendor` : `Update Vendor`}</h1>
                                <i className="fa-regular fa-circle-xmark text-danger" data-bs-dismiss="modal" onClick={this.closeModal}></i>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-4 mb-2">
                                        <label className="form-label text-sm">Travelcircuit *</label>
                                        <select
                                            name="travelCircuitId"
                                            value={travelCircuitId}
                                            className="form-control-sm border border-primary form-select w-100"
                                            onChange={this.handleChange}
                                        >
                                            <option value="0">-- Select --</option>
                                            {tcData.map((item, index) => (
                                                <option key={index} value={item.TravelCircuitId}>
                                                    {item.TravelCircuitName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-4 mb-2">
                                        <label className="form-label text-sm">Location *</label>
                                        <select
                                            name="locationId"
                                            value={locationId}
                                            className="form-control-sm border border-primary form-select w-100"
                                            onChange={this.handleChange}
                                        >
                                            <option value="0">-- Select --</option>
                                            {locationData.map((item, index) => (
                                                <option key={index} value={item.LocationId}>
                                                    {item.LocationName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-4 mb-2">
                                        <label className="form-label text-sm">Vendor Category *</label>
                                        <select
                                            className="form-control-sm border border-primary form-select w-100"
                                            name="vendorCategoryId"
                                            value={vendorCategoryId}
                                            onChange={this.handleChange}
                                        >
                                            <option value="0">-- Select --</option>
                                            {vendorCategoryData.map((item, index) => (
                                                <option key={index} value={item.VendorCategoryId}>
                                                    {item.VendorCategoryName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-4 mb-2">
                                        <label className="form-label text-sm">Vendor Name *</label>
                                        <input type="text"
                                            className="form-control-sm border border-primary w-100"
                                            name="vendorName"
                                            value={vendorName}
                                            onChange={this.handleChange}
                                        />
                                    </div>
                                    <div className="col-md-4 mb-2">
                                        <label className="form-label text-sm">Contact No. * </label>
                                        <input type="text"
                                            className="form-control-sm border border-primary w-100"
                                            name="contactNo"
                                            value={contactNo}
                                            onChange={this.handleChange}
                                        />
                                    </div>
                                    <div className="col-md-4 mb-2">
                                        <label className="form-label text-sm">Contact Person </label>
                                        <input type="text"
                                            className="form-control-sm border border-primary w-100"
                                            name="contactPerson"
                                            value={contactPerson}
                                            onChange={this.handleChange}
                                        />
                                    </div>
                                    <div className="col-md-8 mb-2">
                                        <label className="form-label text-sm">Email * </label>
                                        <input
                                            type="text"
                                            className="form-control-sm border border-primary w-100"
                                            name="email"
                                            value={email}
                                            onChange={this.handleChange}
                                        />
                                    </div>
                                    <div className="col-md-4 mb-2">
                                        <label className="form-label text-sm">Licence No.</label>
                                        <input type="text"
                                            className="form-control-sm border border-primary w-100"
                                            name="licenceNo"
                                            value={licenceNo}
                                            onChange={this.handleChange}
                                        />
                                    </div>
                                    <div className="col-md-12 mb-2">
                                        <label className="form-label text-sm">Address</label>
                                        <input
                                            type="text"
                                            className="form-control-sm border border-primary w-100"
                                            name="addressLine"
                                            value={addressLine}
                                            onChange={this.handleChange}
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label text-sm">CIN </label>
                                        <input type="text"
                                            className="form-control-sm border border-primary w-100"
                                            name="cin"
                                            value={cin}
                                            onChange={this.handleChange}
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label text-sm">GSTIN </label>
                                        <input type="text"
                                            className="form-control-sm border border-primary w-100"
                                            name="gstin"
                                            value={gstin}
                                            onChange={this.handleChange}
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label className="form-label text-sm">PAN *</label>
                                        <input type="text"
                                            className="form-control-sm border border-primary w-100"
                                            name="pan"
                                            value={pan}
                                            onChange={this.handleChange}
                                        />
                                    </div>
                                    <div className="col-md-12">
                                        <label className="form-label text-sm">Comment</label>
                                        <input type="text"
                                            className="form-control-sm border border-primary w-100"
                                            name="comment"
                                            value={comment}
                                            onChange={this.handleChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer my-3">
                                <button
                                    type="submit"
                                    className="btn btn-success button-box-shadow"
                                    onClick={this.handleSubmit}
                                >
                                    <i className="fa-regular fa-floppy-disk"></i> Save
                                </button>
                                {
                                    this.state.userRole === 'admin' &&
                                    <button
                                        type="button"
                                        className={`btn btn-danger button-box-shadow curser-pointer ${vendorId > 0 ? '' : 'disabled'}`}
                                        onClick={() => { vendorId > 0 && this.openWarnModal() }}
                                    >
                                        <i className="fa-solid fa-trash-can"></i> Delete
                                    </button>
                                }
                                <button
                                    type="button"
                                    className="btn btn-secondary button-box-shadow"
                                    data-bs-dismiss="modal"
                                    onClick={this.closeModal}
                                >
                                    <i className="fa-solid fa-circle-xmark"></i> Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <!------DELETE Warning Modal--------> */}
                <div className={showDeleteWarnModal === true ? "modal show-modal" : "modal"}>
                    <div className="modal-dialog modal-dialog-centered modal-md ">
                        <div className="modal-content button-box-shadow">
                            <div className="modal-body">
                                <div className="alert alert-warning d-flex align-items-center" role="alert" >
                                    <i className="fa-solid fa-triangle-exclamation"></i>&nbsp;
                                    <div><strong>Are you sure</strong>, you want to <strong>Delete </strong> it?</div>
                                </div>
                            </div>
                            <div className="modal-footer ">
                                <button
                                    type="button"
                                    className="btn btn-danger button-box-shadow btn-sm"
                                    onClick={this.handleDelete}
                                >
                                    <i className="fa-solid fa-trash-can"></i> Delete
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-secondary button-box-shadow btn-sm"
                                    data-bs-dismiss="modal"
                                    onClick={this.closeWarnModal}
                                >
                                    <i className="fa-solid fa-circle-xmark"></i> Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Vendor;